import { ListItem, ListItemText, Paper } from "@mui/material";
import React, { useCallback } from "react";

import { useDispatch } from "react-redux";
import UsersPageModal from "../users-page-modal";
import { usersPageSetModal } from "../reducers/users-page-actions";
import OptionsMenu from "../../../../extra-components/options-menu";

const STR = {
  labelEdit: "EDITAR",
  labelDelete: "EXCLUIR",
};

function VariablesItem({ id, name, description }) {
  return (
    <Paper sx={{ my: 0.5 }}>
      <ListItem
        secondaryAction={
          <Options id={id} name={name} description={description} />
        }
      >
        <ListItemText primary={name} secondary={description} />
      </ListItem>
    </Paper>
  );
}

const Options = ({ id, name, description }) => {
  const dispatch = useDispatch();
  //
  const onDelete = useCallback(() => {
    dispatch(
      usersPageSetModal({
        type: UsersPageModal.modal.VARIABLE_DELETE,
        data: id,
      })
    );
  }, [dispatch, id]);
  //
  const onEdit = useCallback(() => {
    dispatch(
      usersPageSetModal({
        type: UsersPageModal.modal.VARIABLE_EDIT,
        data: {
          id,
          name,
          description,
        },
      })
    );
  }, [dispatch, id, name, description]);
  //
  const options = [
    {
      icon: "Edit",
      label: STR.labelEdit,
      onClick: onEdit,
    },

    {
      icon: "Delete",
      label: STR.labelDelete,
      onClick: onDelete,
    },
  ];
  return <OptionsMenu options={options} />;
};

export default VariablesItem;
